// @flow

import { isMobileScreen } from "../../Library/Window";

export function isMobile() {
  return isMobileScreen();
}
